import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
  useTheme
} from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import ExpandLessIcon from "@mui/icons-material/ExpandLess"
import React, { useState } from "react"
import styles from "../../../dmvmenu.module.scss"
import { Col, Row } from "react-bootstrap"
import AppTextField from "components/StyledComponents/AppTextField"

const HistoryForm = ({ formik }) => {
  const theme = useTheme()
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div>
      <Box
        flexDirection="column"
        className={styles.accordian_container}
        sx={{
          backgroundColor: isExpanded
            ? theme.palette.background.main
            : theme.palette.background.default,
          paddingBottom: !isExpanded && "0px !important",
          margin: isExpanded && "36px 0px !important"
        }}>
        <Accordion expanded={isExpanded} onChange={() => setIsExpanded(!isExpanded)}>
          <AccordionSummary className={styles.summary}>
            <Box display="flex" alignItems="center" gap={1}>
              {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              <Typography variant="bodyLyon">History</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Row className="w-100 m-0 mt-4 mb-4">
              <Col lg="12">
                <AppTextField
                  id={`heading`}
                  name={`heading`}
                  label="Heading"
                  isUpperCase={true}
                  type="text"
                  fullWidth
                  placeholder={`Enter Heading`}
                  value={formik.values.item_history?.heading || ""}
                  onChange={(event) => {
                    formik.setFieldValue(`item_history.heading`, event.target.value)
                  }}
                  onBlur={formik.handleBlur(`item_history.heading`)}
                  error={Boolean(formik.errors?.item_history?.heading)}
                  helperText={formik.errors?.item_history?.heading}
                />
              </Col>
              <Col lg="12" className="mt-4">
                <AppTextField
                  id={`content`}
                  name={`content`}
                  label="Content"
                  isUpperCase={true}
                  type="text"
                  fullWidth
                  placeholder={`Enter Content`}
                  value={formik.values.item_history?.content || ""}
                  onChange={(event) => {
                    formik.setFieldValue(`item_history.content`, event.target.value)
                  }}
                  onBlur={formik.handleBlur(`item_history.content`)}
                  error={Boolean(formik.errors?.item_history?.content)}
                  helperText={formik.errors?.item_history?.content}
                />
              </Col>
            </Row>
          </AccordionDetails>
        </Accordion>
      </Box>
    </div>
  )
}

export default HistoryForm
